import { Component, inject, OnInit } from '@angular/core';

import { AbstractDynamicDialogComponent } from '../../../components/dynamic-dialog/abstract-dynamic-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { EMAIL_PATTERN_STRING } from '../../../consts/patterns.const';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { getErrorMessage } from '../../../consts/form-field-errors';

@Component({
  selector: 'apply-to-estimage-pay-modal',
  imports: [FormsModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
  template: `
    <form [formGroup]="form" (ngSubmit)="saveOrExecuteAction()" class="mt-15 flex flex-col gap-20">
      <span>
        Please provide your e-mail address. A verification code will be sent to that e-mail to allow you to access your
        onboarding form.
      </span>

      <mat-form-field>
        <mat-label>Email</mat-label>
        <input formControlName="email" matInput />
        @if (email.hasError('required') || email.hasError('pattern')) {
          <mat-error>
            @if (email.hasError('required')) {
              <span>Email is </span>
            }
            <strong>{{ getErrorMessage(email.errors) }}</strong>
          </mat-error>
        }
      </mat-form-field>
    </form>
  `
})
export class ApplyToEstImagePayModalComponent extends AbstractDynamicDialogComponent<void> implements OnInit {
  #dialogRef = inject(MatDialogRef<ApplyToEstImagePayModalComponent>);
  #fb = inject(FormBuilder);

  protected readonly getErrorMessage = getErrorMessage;

  get email() {
    return this.form.controls.email;
  }

  constructor() {
    super();
    this.form = this.#fb.group({
      email: ['', [Validators.required, Validators.pattern(EMAIL_PATTERN_STRING)]]
    });
  }

  ngOnInit() {
    this.dynamicDialogService.dialogRefSignal.set(this.#dialogRef);
  }

  saveOrExecuteAction() {
    if (this.form.valid) {
      this.#dialogRef.close(this.email.value);
    }
  }
}
